import { BTable, BFormGroup, BFormInput, BFormCheckbox, } from "bootstrap-vue";
import Loading from '@@/core/components/shared/Loading/Loading'
import Back from "@@/core/components/shared/Back/Back";

export default {
    name: "ChangeStatus",
    components: {
        Loading,Back,
        BTable, BFormGroup, BFormInput, BFormCheckbox
    },
    data() {
        return {
            items: [],
            id: this.$route.params.id,
            productSku: "",
            disabled: false,
            returnMode: false,
            varieties: [],
            reqDiasableStyle: true,
            DiasableSubmit: false,
        };
    },
    watch: {
    },
    created() {
        if(this.$route.query.type=="all"){
            this.loadData();
        }else if(this.$route.query.type=="return"){
            this.returnRequest();
        }else{
            this.onceRequest();
        }
    },
    methods: {
        async loadData() {
            const response = await await this.$axios.get("admin/all-pending-sellers-requests/" + this.id);
            this.items = response.data.data.sellerRequests;
        },
        listenForKeyPress() {
            document.removeEventListener("keyup", this.onKeyPress);
            document.addEventListener("keyup", this.onKeyPress);
        },
        returnRequest(){
            this.returnMode = true;
            this.items.push({
                seller:{full_name:this.$route.query.seller_name},
            });
        },
        onceRequest(){
            this.items.push({
                var_name:this.$route.query.var_name,
                seller:{full_name:this.$route.query.seller_name},
            });
        },
        onKeyPress(e) { },
        async requestProduct() {
            try {
                this.disabled = true;
                const response = await this.$axios.get("admin/mini_orders/search", {
                    params: {
                        barcode: this.productSku,
                        refund: false,
                    },
                });
                this.productSku = "";
                const variety = response.data.data.variety;
                this.varieties.push(variety);
            } catch (e) {
                this.$root.notify(e);
            } finally {
                this.disabled = false;
                this.$nextTick(() => {
                    this.$refs.productSku.focus();
                });
            }
        },
        async submit() {
            let fd = new FormData();
            console.log(this.varieties,'this.varieties');
            
            this.varieties.forEach((item, index) => {
                fd.append(`barcodes[${index}]`, item.barcode);
            });
            try {
                this.reqDiasableStyle = false;
                this.disabled = true;
                let response = null;
                if (this.returnMode) {
                    response = await this.$axios.post("admin/change-status-seller-requests-to-return", fd);
                }else{
                    console.log(fd,'fdfdfdfd');
                    
                    response = await this.$axios.post("admin/change-status-seller-requests-to-complete", fd);
                }
                this.$root.notify(response.data.message, "success");
                this.$router.push(`/admin/sales-management/${this.id}`);
            } catch (e) {
                this.$root.notify(e);
            } finally {
                this.disabled = false;
                this.reqDiasableStyle = true;
            }
        },
    },
};






















